export default __webpack_public_path__ + "static/ng-df785e554ba2bdbdff668a36d415834c.jpg";